export default "__VITE_PUBLIC_ASSET__3d259452__"